import {throttle} from 'throttle-debounce';

const initStickyBookingForm = () => {
    let sidebar = document.getElementsByClassName('sidebar');
    if (sidebar.length === 0) {
        return;
    }
    sidebar = sidebar[0];
    const bookingForm = document.getElementById('booking-form__react-anchor');
    const content = document.getElementsByClassName('content');
    const isBookingFormLastItem = sidebar.children[sidebar.children.length - 1] === bookingForm;
    if (!isBookingFormLastItem) {
        return;
    }
    let bookingFormDistanceFromTop = bookingForm.offsetTop;
    let bookingFormHeight = bookingForm.getBoundingClientRect().height;
    let contentHeight = 0;

    if (content.length > 0) {
        contentHeight = content[0].getBoundingClientRect().height;
    }

    window.addEventListener('resize', () => {
        bookingFormDistanceFromTop = bookingForm.offsetTop;
        bookingFormHeight = bookingForm.getBoundingClientRect().height;

        if (content.length > 0) {
            contentHeight = content[0].getBoundingClientRect().height;
        }
    });

    window.addEventListener('scroll', throttle(100, (e) => {
        if (window.innerWidth < 960 || window.innerHeight < bookingFormHeight) {
            bookingForm.style.marginTop = 0;
            return;
        }
        if (window.pageYOffset > bookingFormDistanceFromTop && window.pageYOffset < contentHeight - bookingFormHeight + 160) {
            bookingForm.style.marginTop = `${window.pageYOffset - bookingFormDistanceFromTop + 60}px`;
            return;
        }
        if (window.pageYOffset < bookingFormDistanceFromTop) {
            bookingForm.style.marginTop = 0;
        }
    }));
};

export default initStickyBookingForm;
